import React from 'react'

import AddPortfolioView from "./add-view/add-portfolio-view"
import ErrorBoundary from "../../../../../core/error-boundary"
import ProjectCollectionMenuMore from "./more-views/more-views"
import ReorderList from "../../../../../core/gd-ui/sortable-list-4/reorder-list"
import SubmenuItem from "./submenu-item/submenu-item"
import ProjectCollectionView from "../../../../../core/manager/project-collection/project-collection-views/project-collection-view"
import {ViewType} from "../../../../../core/gd/const/views/view-type"
import {ReorderListType} from "../../../../../core/gd-ui/sortable-list-4/reorder-list-no-div"
import PortfolioMoreButton from "./more-button/more-button"

type Props = {

}

// const debug = "PortfolioSubmenu"
const debug = false

export default class PortfolioSubmenu extends React.Component<Props> {

    private isEditorAccessUser  : boolean
    private views               : any[] = []
    private viewsNotFit         : any[] = []

    private menuInfo!           : ProjectCollectionView

    constructor(props: Props) {
        super(props)

        const projectCollection = gd.session.projectCollections.get(gd.projectCollectionViews.projectCollectionId)
        this.isEditorAccessUser = projectCollection!.isEditorAccessUser
    }

    componentDidMount() {
        gd.layout.on('change:widthMain', this.update, this)

        gd.bus.subscribe('top:submenu-update', this, this.update)
    }

    componentWillUnmount() {
        gd.layout.off('change:widthMain',this.update,this)

        gd.bus.unsubscribe(this)
    }

    update = () => {this.forceUpdate()}

    _getItemWidth = (name: string, isSelected: boolean) => {
        //prepare div styles
        const styles: any = {'text-transform': 'uppercase'}
        if (isSelected) styles['font-weight'] = 700

        //calculate item width
        const textWidth = gd.utils.getTextWidth(name, 13, null, styles) + 1 //1 is for fractional values correction;
        const additionalWidth = 24/*24px padding */
        let itemWidth = textWidth + additionalWidth
        if (itemWidth > 220) itemWidth = 220
        return itemWidth + 8/*8px margin*/
    }

    prepareViews = () => {
        let views: any[] = [], viewsNotFit: any[] = []
        let submenuWidth = 20 //20px is submenu position left

        this.menuInfo = new ProjectCollectionView({
            id          : 'info',
            systemType  : ViewType.PORTFOLIO_INFO,
        }, gd.session.projectCollections.get(gd.projectCollectionViews.projectCollectionId)!)

        //add all mandatory items
        submenuWidth += 76 + 8 //VIEWS 76px width + 8px margin

        if (this.menuInfo) submenuWidth += 56; //INFO 56px width

        if (this.isEditorAccessUser) {
            submenuWidth += 1 + 10 //Separator 1px width + 10px margin
            submenuWidth += 33 //More 33px width
            submenuWidth += 80 //Add View btn
        }

        let currentViewId: ID | null = null
        if (gd.projectCollectionViews.currentView) {
            // add width of currently selected unpinned view, we need to reserve space for it
            submenuWidth += this._getItemWidth(gd.projectCollectionViews.currentView.name, true)
            currentViewId = gd.projectCollectionViews.currentView.id
        }

        let currentViewIsVisible = false
        _.map(gd.projectCollectionViews.views, projectCollectionView=>{

            // check if this view is currentView
            const id = projectCollectionView.id
            const isCurrentView = currentViewId === id

            // current view item width has been already added and no need to calculate and add its width again
            if (!isCurrentView) {
                const name = projectCollectionView.name // get visible name
                const isSelected = projectCollectionView.id === gd.projectCollectionViews.currentView?.id

                // calculate item width
                submenuWidth += this._getItemWidth(name, isSelected)
            }

            // debug && console.log(debug, "render orderedViews map", submenuWidth, gd.layout.widthMain)

            // check if item still fits and add it to views or to viewsNotFit if not
            if (submenuWidth < gd.layout.widthMain) {
                views.push(projectCollectionView)
                if (isCurrentView) currentViewIsVisible = true // mark that current view is visible
            } else {
                viewsNotFit.push(projectCollectionView)
            }
        })

        // if currentView is not among visible views add it as the last one
        // and remove from viewsNotFit
        if (!currentViewIsVisible && currentViewId) {
            views.push(gd.projectCollectionViews.currentView)
            _.remove(viewsNotFit, view=>view.id === currentViewId)
        }

        this.views = views
        this.viewsNotFit = viewsNotFit
    }

    onDragCustomViewsEnd = (items: any[], reorderedItem: any) => {
        debug && console.log(debug, "onDragCustomViewsEnd", items, reorderedItem)

        // update sortPosition for visible views
        _.map(items, (item, key)=>{item.sortPosition = key})

        // update sortPosition for hidden views
        const nextKey = items.length
        _.map(this.viewsNotFit, (view, key)=>{
            view.sortPosition = nextKey + key
        })

        gd.projectCollectionViews.sortViews()
        gd.projectCollectionViews.save()
    }

    renderViewsList() {
        debug && console.log(debug, "renderViewsList")

        const components = _.map(this.views, view=>({
            item        : view,
            component   : <SubmenuItem projectCollectionView={view}/>
        }));

        return <ReorderList type={ReorderListType.HORIZONTAL} items={components} keyFunction={item=>item.id} onReorder={this.onDragCustomViewsEnd}/>
    }

    render() {
        this.prepareViews()
        const projectCollectionId = gd.projectCollectionViews.projectCollectionId

        debug && console.log(debug, "render", projectCollectionId, this.views, this.viewsNotFit)

        return (
            <div className="ui5-hmenu menu-underline">
                <ErrorBoundary>
                    {this.renderViewsList()}
                </ErrorBoundary>

                {this.menuInfo && <SubmenuItem projectCollectionView={this.menuInfo}/>}

                {this.viewsNotFit && this.viewsNotFit.length > 0 && <ProjectCollectionMenuMore projectCollectionId={projectCollectionId} additionalViews={this.viewsNotFit}/>}

                {this.isEditorAccessUser &&
                    <ErrorBoundary>
                        <div className="v-separator"/>
                        <AddPortfolioView className="m-r-10" projectCollectionId={projectCollectionId}/>

                        <PortfolioMoreButton/>
                    </ErrorBoundary>}
            </div>
        );
    }
}